export const useHelpers = () => {
  const mergeArrayByProp = (target, source, prop) => {
    source.forEach(sourceElement => {
      const targetElement = target.find(targetElement => {
        return sourceElement[prop] === targetElement[prop];
      })
      targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
    });

    return target;
  }

  return {
    mergeArrayByProp
  };
};
